// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1R9-t","productName":"Table_productName__1M0_g"};